import { Injectable } from '@angular/core';
import { EmailCommunicationPreferences, EmailCommunicationPreferencesPayload } from '@core/models/communication.model';
import { HttpRestService } from '@core/services/http-rest.service';
import { APIResponse } from '@yourcause/common';

@Injectable({
  providedIn: 'root'
})
export class EmailCommunicationResources {
  constructor (
    private httpRestService: HttpRestService
  ) { }

  async getEmailCommunicationPreferences (userEmailAddress?: string) {
    const response = await this.httpRestService.post<APIResponse<EmailCommunicationPreferences>>(
      'api/CommunicationPreference/GetUserCommunicationPreferences',
      {
        userEmailAddress
      }
    )
    ;

    return response.data;
  }

  async updateEmailCommunicationPreferences (
    payload: EmailCommunicationPreferencesPayload
  ) {
    const endpoint = 'api/CommunicationPreference/UpdateUserEmailPreference';

    return this.httpRestService.post<APIResponse>(endpoint, payload)
    ;
  }
}
